import React from 'react';

import { Container, Grid } from '@mui/material';
import Typography from '@mui/material/Typography';

interface ErrorBoundaryState {
    hasError: boolean;
}

export class PageErrorBoundary extends React.Component<React.PropsWithChildren, ErrorBoundaryState> {
    constructor(props: React.PropsWithChildren) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        // TODO: send the logs to
        // A: - BE
        // B: - cloud
        console.log('componentDidCatch', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Container>
                    <Grid container spacing={3}>
                        <Grid xs={12} sx={{ margin: '20px', color: '#c00' }}>
                            <Typography variant="h1">Something went wrong</Typography>
                        </Grid>
                        <Grid xs={12} sx={{ margin: '20px', color: '#c00' }}>
                            <Typography variant="body1">We sent the error report to the developer team.</Typography>
                        </Grid>
                    </Grid>
                </Container>
            );
        }

        return this.props.children;
    }
}
